import '@kaena1/mm-ui-theme-v3/styles.css';
import React from 'react';
import {theme} from '@kaena1/mm-ui-theme-v3';
import {Countdown, ThemeProvider} from '@kaena1/mm-ui-components';

interface AppProps {
  endDate: Date;
}
export const App = ({endDate}:AppProps) => {
  return (
    <ThemeProvider theme={theme}>
        <Countdown
          endDate={endDate}
        />
    </ThemeProvider>
  );
};